import React from "react";

import { useTranslation } from "react-i18next";

import money from '../../img/money.png'

function Conclusion () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[120px] pb-[80px] xl:pb-[120px]">
            <div className="xl:h-[267px] bg-[#9D0032] flex flex-col-reverse xl:flex-row items-center">
                <img src={money} alt="" />
                <div className="p-[20px]">
                    <p className="text-white text-[20px] xl:text-[40px] manrope font-[500]">{t('home.44')}</p>
                    <p className="mt-[20px] xl:mt-[40px] xl:max-w-[500px] manrope text-white text-[14px] leading-[1.4]">{t('home.45')}</p>
                </div>
            </div>
        </div>
    );
}

export default Conclusion;